import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export const useTabsConfig = ({
  isPartner
}) => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  const {
    pathname
  } = useLocation();
  const isViewingOtherUserProfile = /^\/profile\/\d+$/.test(pathname);
  const tabs = [{
    exact: true,
    tabId: I18n.text('academy-navigation-lib.ACPage.tabs.home'),
    to: '/',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.home"
    })
  }, {
    exact: true,
    tabId: I18n.text('academy-navigation-lib.ACPage.tabs.myLearning'),
    to: '/my-learning',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myLearning"
    })
  }, {
    exact: true,
    tabId: I18n.text('academy-navigation-lib.ACPage.tabs.watchLater'),
    to: '/watch-later',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.watchLater"
    })
  }, {
    tabId: I18n.text('academy-navigation-lib.ACPage.tabs.myPlaylists'),
    to: '/saved-items/playlists',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myPlaylists"
    })
  }, {
    exact: isViewingOtherUserProfile,
    tabId: I18n.text('academy-navigation-lib.ACPage.tabs.myProfile'),
    to: '/profile',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-navigation-lib.ACPage.tabs.myProfile"
    })
  }];
  if (!isMobileNavbar) {
    tabs.push({
      tabId: I18n.text('academy-navigation-lib.ACPage.tabs.myTeam'),
      to: '/my-team',
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.tabs.myTeam"
      })
    });
  }
  if (isPartner) {
    tabs.push({
      exact: true,
      tabId: I18n.text('academy-navigation-lib.ACPage.tabs.partnerTraining'),
      to: '/partners',
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.tabs.partnerTraining"
      })
    });
  }
  return tabs;
};